import React from 'react';
import { useState } from 'react';
import NonOptOutIndicatorIcon from '@assets/icons/notifications/non-opt-out-indicator.svg';
import { BaseTooltip } from '@components';
import { TEST_IDS } from '@constants/testIds.ts';
import { useLingui } from '@lingui/react/macro';
import { TooltipContent } from '@routes/___shared___/styled.tsx';
import { isNotificationNew, showNonOptOutIndicator } from '@routes/sidebar/notifications/___shared___/helpers.ts';
import type { NotificationDetails } from '@routes/sidebar/notifications/api/notifications.api.ts';
import CardActions from '@routes/sidebar/notifications/ui/card-actions';
import { Card, CardHeader, NonOptOutIndicator } from '@routes/sidebar/notifications/ui/notification-card/styled.tsx';

import CardInfo from '../card-info';

interface Props {
    note: NotificationDetails;
}

const NotificationCard: React.FC<Props> = ({ note }) => {
    const { t } = useLingui();
    const [isNotifyHidden, setIsNotifyHidden] = useState(true);
    const notificationType = note?.notificationType;
    const notificationSource = note?.notificationSource;

    if (!notificationType) {
        return <div key={note.id}>{note.id}</div>;
    }

    return (
        <Card
            key={note.id}
            $type={note.notificationType}
            $source={note.notificationSource}
            $isExpanded={!isNotifyHidden}
            $wasRead={note.wasRead}
            $isNew={isNotificationNew(note)}
            data-cy={TEST_IDS.NOTIFICATIONS.NOTIFICATION_CARD}
            data-notification-id={note.id}
        >
            <CardHeader>
                {showNonOptOutIndicator(notificationType, notificationSource) && (
                    <BaseTooltip
                        title={<TooltipContent>{t`This notification cannot be disabled`}</TooltipContent>}
                        arrow={false}
                        placement={'topLeft'}
                    >
                        <NonOptOutIndicator>
                            <NonOptOutIndicatorIcon />
                        </NonOptOutIndicator>
                    </BaseTooltip>
                )}
                <CardInfo note={note} isNotifyHidden={isNotifyHidden} />
                <CardActions note={note} isNotifyHidden={isNotifyHidden} setIsNotifyHidden={setIsNotifyHidden} />
            </CardHeader>
        </Card>
    );
};

export default NotificationCard;
